export default {
  en: {
    title: 'Sign in with SSO',
    emailLabel: 'Email',
    emailRequired: 'Enter your email address',
    backToLogin: 'Back to login',
    tryAgain: 'Try again',
    error: 'Failed to sign-in with SSO. Please try again.',
    failed: 'Failed to sign-in with SSO',
    apiError: 'Oops something went wrong',
    unsupportedSSOProvider: 'Unsupported SSO provider. Please contact support.',
    genericError: 'An error occurred during SSO authentication. Please try again.',
    signingIn: 'Signing in...',
    ssoCallbackTitle: 'Signing in',
    sso_enforced: 'Your organisation has enforced single sign-on. Please login below.',
    account_locked:
      'Your account has been locked. Please contact your team lead or\n    a Customer Success Manager to unlock your account.',
    oauth: {
      failed: 'Failed to sign-in with Google',
      apiError:
        'Make sure to use the same email that you registered with on Risk Ledger, and that your organisation Admins have enabled Google OAuth sign-in in the Risk Ledger settings.',
    },
  },
};
